<template>
  <el-dialog
    class="iffttt_effect_time_dialog"
    :visible="visible"
    :modal-append-to-body="false"
    @close="handlerClose"
  >
    <div class="blue_border">
      {{ $t('iftttset.effectivetime') }}
    </div>
    <div class="dataing_line clearfix marbottom" style="margin-bottom: 20px">
      <span class="dataing_label">{{ $t('iftttset.repeat') }}</span>
      <div class="dataing_left">
        <!-- 重复 -->
        <div>
          <span
            v-for="(item, index) in !isIot1() && !triggerManual ? weekTemp : weekTemp2"
            :key="item.index"
            :style="(item.value === 'holidays' || item.value === 'notHolidays') && !isConfigured ? { paddingLeft: '35px', color: 'rgba(61, 61, 61, 0.5)' } : {}"
            class="week_list"
            :class="[item.selected ? 'blueData' : '']"
            @click="weekCustomize(index)"
          >
            {{ item.name }}
            <img :src="data_select">
            <img
              v-if="(item.value === 'holidays' || item.value === 'notHolidays') && !isConfigured"
              :class="{ warning: !isConfigured }"
              src="@/assets/img/projicttMsg/warning2.png"
              alt=""
            ></span>
        </div>
        <div v-if="weekSetShow" class="dataing_interval">
          {{ $t('iftttset.weekTip') }}
        </div>
        <div v-if="weekSetShow">
          <div class="custom_type_list">
            <el-radio-group v-model="customType" size="mini" class="conditioner_wind custom-type-radio-group">
              <el-radio v-for="(d, i) in customTypeList" :key="i" :label="d.value">
                {{ d.name }}
              </el-radio>
            </el-radio-group>
          </div>
          <template v-if="customType === CUSTOMTYPE_ENUM.WEEK">
            <span
              v-for="(item, index) in week"
              :key="index"
              class="week_list"
              :class="item.selected ? 'blueData' : ''"
              @click="dataSelect(index)"
            >
              {{ item.name }}
              <img :src="data_select">
            </span>
          </template>
          <OppleDatePicker
            v-if="customType === CUSTOMTYPE_ENUM.MONTH"
            ref="OppleDatePicker"
            v-model="selectMonthDateList"
            :show-quick-actions="true"
            :is-single="true"
            :column="3"
            :year="year"
            :holiday-list="emptyList"
            :range="emptyList"
            :filter-list="emptyList"
          />
          <template v-if="customType === CUSTOMTYPE_ENUM.YEAR">
            <span
              v-for="(item, index) in monthList"
              :key="index"
              class="week_list"
              :class="item.selected ? 'blueData' : ''"
              @click="monthsSelect(item)"
            >
              {{ item.name }}
              <img :src="data_select">
            </span>
            <!-- 关联时期设置 -->
            <div class="associated_period_set">
              <span class="associated_period_set_text" @click="associatedPeriodSet">{{ $t('ifttt.associatedDateSettings') }}</span>
              <OppleDatePicker
                v-if="associatedPeriodShow"
                ref="OppleDatePicker"
                v-model="selectYearDateList"
                :show-quick-actions="true"
                :is-single="true"
                :column="3"
                :year="year"
                :holiday-list="emptyList"
                :range="emptyList"
                :filter-list="emptyList"
              />
            </div>
          </template>
          <el-date-picker
            v-if="customType === CUSTOMTYPE_ENUM.DATE_RANGE"
            v-model="dataPickValue"
            type="daterange"
            :range-separator="$t('sylogs.to')"
            start-placeholder="2019-01-01"
            end-placeholder="2088-12-31"
            :picker-options="dateRangePickerOptions"
          />
        </div>
      </div>
    </div>
    <!-- 时间 -->
    <div class="dataing_line clearfix" style="margin-bottom: 20px">
      <span class="dataing_label">{{ $t('iftttset.time') }}</span>
      <div class="dataing_left two_time_box">
        <div>
          <span
            v-for="(item, index) in timeTemp"
            :key="item.index"
            class="week_list"
            :class="item.selected ? 'blueData' : ''"
            @click="timeCustomize(index)"
          > {{ item.name }}<img :src="data_select"> </span>
        </div>
        <div v-if="timeSetShow" class="dataing_interval">
          {{ $t('iftttset.timeTip') }}
        </div>
        <div v-if="timeSetShow" style="margin-bottom: 10px; margin-left: 8px">
          <el-time-picker
            v-model="timeValue.start"
            :editable="true"
            class="two_time_set"
            :placeholder="$t('ifttt.timeStart')"
            popper-class="only_hour"
            format="HH"
            value-format="HH"
          />
          <span class="zhi">{{ $t('iftttset.and') }}</span>
          <el-time-picker
            v-model="timeValue.end"
            :editable="true"
            class="two_time_set"
            :placeholder="$t('ifttt.timeEnd')"
            popper-class="only_hour"
            format="HH"
            value-format="HH"
          />
          <em class="time_text">{{ $t('iftttset.hour') }}</em>
        </div>
      </div>
    </div>
    <!-- 日期 实则不可以编辑-->
    <!-- <div class="dataing_line clearfix" style="margin-bottom: 20px">
      <span class="dataing_label">{{ $t('iftttset.data') }}</span>
      <div class="dataing_left">
        <div class="scence_ctr_NonJoin">
          <span
            v-for="item in dateTemp"
            :key="item.index"
            class="week_list"
            :class="item.selected ? 'blueData' : ''"
          >
            {{ item.name }}<img :src="data_select">
          </span>
        </div>
        <div v-if="dateSetShow" class="dataing_interval">
          {{ $t('iftttset.dataTip') }}
        </div>
        <div v-if="dateSetShow" style="margin-bottom: 10px">
          <el-date-picker
            v-model="dataValue"
            disabled
            class="time_set"
            type="daterange"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            :start-placeholder="$t('sylogs.startdate')"
            :end-placeholder="$t('sylogs.enddate')"
            :clearable="false"
          />
          <el-checkbox v-model="isHolidayChecked" class="out_day" disabled>
            {{ $t('iftttset.butholiday') }}
          </el-checkbox>
        </div>
      </div>
    </div> -->
    <div style="width: 100%; height: 1px; background: rgb(153 153 153 / 100%); opacity: 0.2" />
    <div slot="footer" class="dialog-footer" style="margin-top: 20px; margin-bottom: 20px">
      <div class="button button-ok" type="primary" @click="handlerOk">
        {{ $t('iftttset.sure') }}
      </div>
      <div class="button" @click="handlerClose">
        {{ $t('iftttset.cancle') }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import img1 from '@/assets/img/icon-selected.png'
import { GetProjectHolidays } from '@/axios/IProject.js'
import { isExistPermission } from '@/components/OppleAuth/index.vue'
import store from '@/store'
import OppleDatePicker from '@/components/OppleDatePicker/Single'
import moment from 'moment'
import { buildDate, buildMonth, parseDate } from '@/utils/utils.js'
import { warning } from '@/assets/js/common.js'
import { isIot3,isIot1 } from "@utils/utils";

//定义自定义的枚举
export const CUSTOMTYPE_ENUM = {
  WEEK: 1,
  MONTH: 2,
  YEAR: 3,
  DATE_RANGE: 4,
}


export default {
  components: {
    OppleDatePicker,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: '',
    },
    // weekTemp: {
    //   type: Array,
    //   default: () => [],
    // },
    effectiveTimeData: {
      type: Object,
      default: () => ({}),
    },
    triggerManual: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emptyList: [],
      year: new Date().getFullYear(),
      // 1: this.$t('monitor.January'),
      //   2: this.$t('monitor.February'),
      //   3: this.$t('monitor.March'),
      //   4: this.$t('monitor.April'),
      //   5: this.$t('monitor.May'),
      //   6: this.$t('monitor.June'),
      //   7: this.$t('monitor.July'),
      //   8: this.$t('monitor.August'),
      //   9: this.$t('monitor.September'),
      //   10: this.$t('monitor.October'),
      //   11: this.$t('monitor.November'),
      //   12: this.$t('monitor.December'),
      dataPickValue: [],
      dateRangePickerOptions: {
        disabledDate(time) {
          const todayStart = new Date()
          todayStart.setHours(0, 0, 0, 0)
          return time.getTime() < todayStart.getTime()
        },
      },
      customType: 1,
      monthType: 1,
      timingset: false,
      data_select: img1,
      week: [],
      weekTemp: [],
      weekTemp2: [],
      timeTemp: [],
      dateTemp: [],
      dataValue: [], // 生效日期
      timeOption: [], // 定时集合
      triggleTime: [], // triggle选中的定时集合
      selectMonthDateList: [],
      selectYearDateList: [],
      customTypeList: [
        { name: this.$t('ifttt.weekly'), value: 1 },
        { name: this.$t('ifttt.monthly'), value: 2 },
        { name: this.$t('ifttt.yearly'), value: 3 },
        { name: this.$t('iftttset.dateRange'), value: 4 },
      ],
      monthList: [
        { name: this.$t('monitor.January'), value: 1, selected: false },
        { name: this.$t('monitor.February'), value: 2, selected: false },
        { name: this.$t('monitor.March'), value: 3, selected: false },
        { name: this.$t('monitor.April'), value: 4, selected: false },
        { name: this.$t('monitor.May'), value: 5, selected: false },
        { name: this.$t('monitor.June'), value: 6, selected: false },
        { name: this.$t('monitor.July'), value: 7, selected: false },
        { name: this.$t('monitor.August'), value: 8, selected: false },
        { name: this.$t('monitor.September'), value: 9, selected: false },
        { name: this.$t('monitor.October'), value: 10, selected: false },
        { name: this.$t('monitor.November'), value: 11, selected: false },
        { name: this.$t('monitor.December'), value: 12, selected: false },
      ],
      weekSetShow: false, // 选择星期是否可见
      timeSetShow: false, // 选择时间是否可见
      dateSetShow: true, // 选择日期是否可见
      timeValue: {
        start: '',
        end: '',
      },
      // timeSet: '', // 选择的时间，
      // timeSetend: '', // 选择的结束时间
      isHolidayChecked: false, // 是否排除节假日
      // timetype: 0, // 0生效时间 1/定时
      effectivetimetitle: '',
      isConfigured: true,
      associatedPeriodShow: false,
      CUSTOMTYPE_ENUM,
    }
  },
  computed: {
    activeWeekTemp() {
      return !this.isIot1() ? this.weekTemp : this.weekTemp2
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.initData(this.effectiveTimeData)
      }
    },
    // 针对自定义自动化：弹窗打开后不再响应外部数据变化，避免编辑中被 initData 重置
    effectiveTimeData: {
      handler(newValue) {
        if (!this.visible) {
          this.initData(newValue)
        }
      },
      deep: true, // 深度监听
    },
    customType(newVal) {
      // 切换到每月或每年时，默认全选日期
      this.$nextTick(() => {
        // if (newVal === CUSTOMTYPE_ENUM.MONTH && this.selectMonthDateList.length === 0) {
        //   this.setDefaultSelectMonthDate()
        // }
        if (newVal === CUSTOMTYPE_ENUM.YEAR && this.selectYearDateList.length === 0) {
          this.setDefaultSelectYearDate()
        }
      })
    },
    triggerManual(newValue) {
      if (newValue) {
        // 当 triggerManual 为 true 时，如果选择了节假日或非节假日，自动切换为每天
        const selectedValue = this.weekTemp.find(item => item.selected).value

        if (selectedValue === 'holidays' || selectedValue === 'notHolidays') {
          // 修改为每天
          this.weekTemp.forEach(item => {
            if (item.value === 'every') {
              item.selected = true // 选择 "每天"
            } else {
              item.selected = false // 取消其他选择
            }
          })

          // 更新视图状态
          this.weekSetShow = false
        }

        this.handlerOk()
      }
    },
  },

  created() {},
  mounted() {
    if (Object.keys(this.effectiveTimeData).length > 0) {
      this.initData(this.effectiveTimeData)
    }
    this.getProjectHolidays(new Date().getFullYear(), false)
  },

  methods: {
    isIot1,
    buildMonthDateList(days = []) {
      return days.map(d => `2099-01-${String(d).padStart(2, '0')}`)
    },
    resolveMonthDateList(selectMonthDateList, dateValue) {
      if (selectMonthDateList && selectMonthDateList.length > 0) {
        return selectMonthDateList
      }
      const days = parseDate(dateValue)
      if (days.length > 0) {
        return this.buildMonthDateList(days)
      }
      return []
    },
    setDefaultSelectMonthDate() {
      // 默认全选每月日期（1-31日）
      this.selectMonthDateList = this.buildMonthDateList(Array.from({ length: 31 }, (_, i) => i + 1))
    },
    setDefaultSelectYearDate() {
      // 默认全选每年关联日期（1-31日）
      this.selectYearDateList = this.buildMonthDateList(Array.from({ length: 31 }, (_, i) => i + 1))
    },
    associatedPeriodSet() {
      //点击关联时间出现选项
      this.associatedPeriodShow = !this.associatedPeriodShow
    },
    async getProjectHolidays(year, isShowMessage = true) {
      const res = await GetProjectHolidays({ Years: [year] })

      if (res.StatusCode == this.$store.state.rightStatusCode) {
        const projectCode = this.$store.state.projectcode
        const projectResult = res.Result?.[year] || []
        const hasHolidayData = projectResult.length > 0
        this.isConfigured = hasHolidayData

        // 如果最终判定为“未配置”
        if (!this.isConfigured) {
          this.activeWeekTemp.forEach(item => {
            if (item.value === 'holidays' || item.value === 'notHolidays') {
              item.selected = false
            }
          })
          // 点击节假日会先 datasSelect(['holidays'])，week 里无该 value，Mon~Sun 会被全取消；
          // 再取消节假日选项后，weekTemp 可能无任何选中项，界面像「每天」没了，但提交仍走默认全周逻辑。
          const stillHasRepeat = this.activeWeekTemp.some(item => item.selected)
          if (!stillHasRepeat) {
            this.activeWeekTemp.forEach(item => {
              item.selected = item.value === 'every'
            })
            this.weekSetShow = false
            this.datasSelect(['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'])
          }

          if (!isShowMessage) return

          const hasPermission = isExistPermission('UpdateProject')
          const title = hasPermission ? this.$t('iftttset.gotoConfig') : this.$t('iftttset.permissionDenied')

          const msg = this.$message({
            message: this.$createElement('span', [
              this.$t('iftttset.notConfigured') + '，',
              this.$createElement(
                'span',
                {
                  style: hasPermission ? 'cursor: pointer; color: #409EFF; text-decoration: underline;' : null,
                  on: {
                    click: () => {
                      if (hasPermission) {
                        this.$router.push({
                          path: '/projectMsg/modify',
                          query: { openHolidayDialog: true },
                        })
                      }
                      store.dispatch('changeRoutermsg', '/projectMsg/modify')
                      msg.close()
                    },
                  },
                },
                title
              ),
            ]),
            type: 'warning',
            duration: 5000,
          })
        }
      }
    },

    initData(value = {}) {
      this.week = [
        { name: this.$t('iftttset.Mon'), selected: true, value: 'Mon' },
        { name: this.$t('iftttset.Tues'), selected: true, value: 'Tues' },
        { name: this.$t('iftttset.Wed'), selected: true, value: 'Wed' },
        { name: this.$t('iftttset.Thur'), selected: true, value: 'Thur' },
        { name: this.$t('iftttset.Fri'), selected: true, value: 'Fri' },
        { name: this.$t('iftttset.Sat'), selected: true, value: 'Sat' },
        { name: this.$t('iftttset.Sun'), selected: true, value: 'Sun' },
      ]
      // 提取共同部分
      const commonData = [
        { name: this.$t('iftttset.every'), selected: true, value: 'every', relation: ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'], flag: 1 },
        { name: this.$t('iftttset.customize'), selected: false, value: 'customize', flag: 1 },
      ]
      this.weekTemp = [...commonData, { name: this.$t('iftttset.wordDay'), selected: false, value: 'wordDay', flag: 1 }, { name: this.$t('iftttset.weekEnd'), selected: false, value: 'weekEnd', flag: 1 }, { name: this.$t('iftttset.holidays'), selected: false, value: 'holidays', flag: 3 }, { name: this.$t('iftttset.notHolidays'), selected: false, value: 'notHolidays', flag: 2 }, { name: this.$t('iftttset.executeOnlyOnce'), selected: false, value: 'executeOnlyOnce', relation: [], flag: 1 }]

      this.weekTemp2 = [...commonData, { name: this.$t('iftttset.wordDay'), selected: false, value: 'wordDay', flag: 1 }, { name: this.$t('iftttset.weekEnd'), selected: false, value: 'weekEnd', flag: 1 }]
      this.timeTemp = [
        { name: this.$t('iftttset.allday'), selected: true, value: 'allday' },
        { name: this.$t('iftttset.customize'), selected: false, value: 'customize' },
      ]
      this.dateTemp = [
        { name: this.$t('iftttset.along'), selected: false, value: 'along' },
        { name: this.$t('iftttset.customize'), selected: true, value: 'customize' },
      ]
      this.dataValue = ['2019-01-01', '2088-12-31']
      this.weekSetShow = false
      this.timeSetShow = false
      //this.dateSetShow = false
      this.isHolidayChecked = false
      this.timeValue = {
        start: '',
        end: '',
      }
      this.customType = 1
      this.selectMonthDateList = []
      this.selectYearDateList = []
      this.dataPickValue = []
      this.monthList.forEach(item => { item.selected = false })

      if (value && Object.keys(value).length > 0) {
        const { flag, time, weeks, zone, repeatInfo, timeInfo, customType, selectMonthDateList, selectYearDateList, selectedMonths, dataPickValue, date } = value

        // 处理 flag 为 4, 5, 6 的情况
        if (flag === 4 || flag === 5 || flag === 6) {
          this.weekSetShow = true
          this.activeWeekTemp.forEach(item => {
            if (item.value === 'customize') {
              item.selected = true
            } else {
              item.selected = false
            }
          })

          // 根据 flag 推断 customType
          if (customType) {
            this.customType = customType
          } 

          if (flag === 4) {
            const monthDateList = this.resolveMonthDateList(selectMonthDateList, date)
            if (monthDateList.length > 0) {
              this.selectMonthDateList = monthDateList
            } else {
              this.setDefaultSelectMonthDate()
            }
          }

          if (flag === 5) {
            if (selectedMonths && selectedMonths.length > 0) {
              this.monthList.forEach(item => {
                item.selected = selectedMonths.includes(item.value)
              })
            }
            if (selectYearDateList && selectYearDateList.length > 0) {
              this.selectYearDateList = selectYearDateList
            } else {
              this.setDefaultSelectYearDate()
            }
          }

          if (flag === 6 && dataPickValue) {
            this.dataPickValue = dataPickValue
          }
        } else {
          this.activeWeekTemp.forEach(item => {
            if (item.name === repeatInfo) {
              if (repeatInfo === this.$t('iftttset.customize')) {
                this.weekSetShow = true
                this.datasSelect(weeks.split(' '))
              }
              item.selected = true
            } else {
              item.selected = false
            }
          })
        }

        let isMatched = false

        this.timeTemp.forEach(item => {
          if (item.name === timeInfo) {
            item.selected = true
            isMatched = true
          } else {
            item.selected = false
          }
        })

        if (!isMatched) {
          this.timeSetShow = true
          this.timeValue.start = time.split(':')[0]?.trim()
          this.timeValue.end = time.split(':')[1]?.trim()
          // 选择另一个特定的 item
          if (this.timeTemp.length > 0) {
            this.timeTemp[1].selected = true // 将第一个元素设置为选中状态
          }
        }
      }
    },

    handlerOk() {
      // 校验自定义时间设置
      if (this.weekSetShow) {
        const validateResult = this.validateCustomData()
        if (!validateResult.valid) {
          warning(this, validateResult.message)
          return
        }
      }

      const effectTimeData = this.getEffectTimeData()
      //const effectivetimetitle = this.geteffectivetimetitle()
      //const timePeriod = this.getTimePeriod()

      this.$emit('effectTimeChange', effectTimeData)
      console.log('effectTimeData', effectTimeData)
      this.handlerClose()
      console.log('timeValue', this.timeValue)
    },

    validateCustomData() {
      switch (this.customType) {
        case CUSTOMTYPE_ENUM.WEEK: {
          const selectedWeeks = this.week.filter(item => item.selected)
          if (selectedWeeks.length === 0) {
            return { valid: false, message: this.$t('iftttset.effectivetimewarning') }
          }
          break
        }
        case CUSTOMTYPE_ENUM.MONTH: {
          if (!this.selectMonthDateList || this.selectMonthDateList.length === 0) {
            return { valid: false, message: this.$t('iftttset.effectivetimewarning') }
          }
          break
        }
        case CUSTOMTYPE_ENUM.YEAR: {
          const selectedMonths = this.monthList.filter(item => item.selected)
          if (selectedMonths.length === 0) {
            return { valid: false, message: this.$t('iftttset.effectivetimewarning')  }
          }
          if (!this.selectYearDateList || this.selectYearDateList.length === 0) {
            return { valid: false, message: this.$t('iftttset.effectivetimewarning')  }
          }
          break
        }
        case CUSTOMTYPE_ENUM.DATE_RANGE: {
          if (!this.dataPickValue || this.dataPickValue.length !== 2) {
            return { valid: false, message: this.$t('iftttset.effectivetimewarning') }
          }
          break
        }
      }
      return { valid: true }
    },

    getEffectTimeData() {
      const repeatData = this.getRepeatData()
      const timeData = this.getTimeData()
      const dayData = this.getDayData()

      const effectTimeData = {
        ...repeatData,
        ...timeData,
        ...dayData,
        zone: 0,
      }
      return effectTimeData
    },

    geteffectivetimetitle() {
      const repeatData = this.getRepeatData()
      const timeData = this.getTimeData()
      const dayData = this.getDayData()

      const title = this.seteffectivetimetitle({
        ...repeatData,
        ...timeData,
        ...dayData,
        zone: 0,
      })

      return title
    },

    getTimePeriod() {
      const repeatData = this.getRepeatData()
      const timeData = this.getTimeData()
      const dayData = this.getDayData()

      const timePeriod = this.setTimePeriod({
        ...repeatData,
        ...timeData,
        ...dayData,
        zone: 0,
      })

      return timePeriod
    },
    //接口请求数据
    setTimePeriod(timePeriod) {
      const effectivedate = timePeriod.effectivedate
      const flag = timePeriod.flag
      const holiday = false
      const time = timePeriod.time
      const weeks = timePeriod.weeks
      const zone = timePeriod.zone

      return {
        effectivedate,
        flag,
        holiday,
        time,
        weeks,
        zone,
      }
    },

    // 获取自定义数据
    getCustomData() {
      const getSelectedWeekName = () => (this.activeWeekTemp.find(item => item.selected) || {}).name
      const DEFAULT_WEEKS = 'Mon Tues Wed Thur Fri Sat Sun'
      const DEFAULT_DATE_PARAMS = { startYear: 0, startMonth: 0, startDay: 0, endYear: 0, endMonth: 0, endDay: 0 }

      const data = {
        repeatInfo: '',
        weeks: '',
        flag: null,
        customType: this.customType,
      }

      switch (this.customType) {
        case CUSTOMTYPE_ENUM.WEEK: {
          const weekList = this.week.filter(item => item.selected).map(item => item.value)
          data.repeatInfo = this.weekCustomizeShown(weekList.join(','), this.activeWeekTemp)
          data.weeks = weekList.join(' ')
          data.flag = (this.activeWeekTemp.find(item => item.selected) || {}).flag
          break
        }

        case CUSTOMTYPE_ENUM.MONTH: {
          const days = this.selectMonthDateList.map(d => moment(d).date())
          Object.assign(data, {
            date: buildDate(days),
            flag: 4,
            month: 0xffff,
            weeks: DEFAULT_WEEKS,
            repeatInfo: getSelectedWeekName(),
            selectMonthDateList: this.selectMonthDateList,
            ...DEFAULT_DATE_PARAMS,
          })
          break
        }

        case CUSTOMTYPE_ENUM.YEAR: {
          const selectedMonth = this.monthList.filter(item => item.selected).map(item => item.value)
          const days = this.selectYearDateList.map(d => moment(d).date())
          Object.assign(data, {
            date: buildDate(days),
            flag: 5,
            month: buildMonth(selectedMonth),
            weeks: DEFAULT_WEEKS,
            repeatInfo: getSelectedWeekName(),
            selectedMonths: selectedMonth,
            selectYearDateList: this.selectYearDateList,
            ...DEFAULT_DATE_PARAMS,
          })
          break
        }

        case CUSTOMTYPE_ENUM.DATE_RANGE: {
          const [start, end] = this.dataPickValue
          Object.assign(data, {
            dateRange: {
              start: moment(start).format('YYYY/M/D'),
              end: moment(end).format('YYYY/M/D'),
            },
            flag: 6,
            weeks: DEFAULT_WEEKS,
            repeatInfo: getSelectedWeekName(),
            startYear: moment(start).format('YYYY'),
            startMonth: moment(start).format('M'),
            startDay: moment(start).format('D'),
            endYear: moment(end).format('YYYY'),
            endMonth: moment(end).format('M'),
            endDay: moment(end).format('D'),
            month: 0xFFFF,
            date: 0xFFFFFFFF,
            dataPickValue: this.dataPickValue,
          })
          break
        }
      }

      return data
    },

    // 获取重复时间数据
    getRepeatData() {
      let repeatInfo = ''
      let weeks = ''
      let flag = null
      let data = null

      if (this.weekSetShow) {
        data = this.getCustomData()
        repeatInfo = data.repeatInfo
        weeks = data.weeks
        flag = data.flag
      } else {
        repeatInfo = (this.activeWeekTemp.find(item => !!item.selected) || {}).name
        const value = (this.activeWeekTemp.find(item => !!item.selected) || {}).value
        flag = (this.activeWeekTemp.find(item => !!item.selected) || {}).flag
        if (value === 'executeOnlyOnce') {
          weeks = ['Once'].join('')
        } else if (value === 'every') {
          weeks = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].join(' ')
        } else if (value === 'wordDay') {
          weeks = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri'].join(' ')
        } else if (value === 'weekEnd') {
          weeks = ['Sat', 'Sun'].join(' ')
        } else {
          weeks = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].join(' ')
        }
      }
      return {
        ...data,
        repeatInfo: repeatInfo,
        weeks: weeks,
        flag: flag,
      }
    },

    // 获取时间数据
    getTimeData() {
      const selectTime = this.timeTemp.find(item => !!item.selected)

      if (selectTime.value === 'allday') {
        return {
          // startDay: '00',
          // endDay: '24',
          timeInfo: selectTime.name,
          time: '00:00',
        }
      }

      if (selectTime.value === 'customize') {
        let { start, end } = this.timeValue
        let timeInfo = ''

        if (start && !end) end = '23'
        if (!start && end) start = '00'

        if (!start && !end) {
          start = '00'
          end = '00'
          // 全天
          timeInfo = this.timeTemp[0].name
        } else {
          const isNestDay = Number(start) >= Number(end)
          timeInfo = `${start} ${this.$t('sylogs.to')} ${isNestDay ? this.$t('iftttset.tommrow') : ''}${end}`
        }

        return {
          // startDay: start,
          // endDay: end,
          timeInfo,
          time: `${start}:${end}`,
        }
      }

      return {}
    },

    // 获取日期数据
    getDayData() {
      if (this.weekSetShow && this.customType === CUSTOMTYPE_ENUM.DATE_RANGE && this.dataPickValue && this.dataPickValue.length === 2) {
        const [start, end] = this.dataPickValue.map(item => moment(item).format('YYYY-MM-DD'))
        return {
          dayInfo: `${start} ${this.$t('sylogs.to')} ${end}`,
          holiday: this.isHolidayChecked,
          effectivedate: `${start},${end}`,
        }
      }

      const selectData = this.dateTemp.find(item => !!item.selected)

      // 目前没有逻辑走进这里
      if (selectData.value === 'along') return {}

      if (selectData.value === 'customize') {
        return {
          // startDay: this.dataValue[0],
          // endDay: this.dataValue[1],
          dayInfo: `${this.dataValue[0]} ${this.$t('sylogs.to')} ${this.dataValue[1]}`,
          holiday: this.isHolidayChecked,
          effectivedate: this.dataValue.join(','),
        }
      }

      return {}
    },

    seteffectivetimetitle(_temTimePeriod) {
      // 生效时间选择好以后 title
      let _title = ''
      _title += _temTimePeriod.repeatInfo

      if (_temTimePeriod.effectivedate === '') {
        if (_title === '') {
          _title = this.$t('iftttset.long')
        } else {
          _title += '#' + this.$t('iftttset.long')
        }
      } else if (_title === '') {
        _title = _temTimePeriod.effectivedate.split(',')[0] + ' ' + this.$t('iftttset.to') + ' ' + _temTimePeriod.effectivedate.split(',')[1]
      } else {
        _title += '#' + _temTimePeriod.effectivedate.split(',')[0] + ' ' + this.$t('iftttset.to') + ' ' + _temTimePeriod.effectivedate.split(',')[1]
      }

      const reg = new RegExp('null', 'g') // 创建正则RegExp对象
      _temTimePeriod.time = _temTimePeriod.time.replace(reg, '00') // 替换null为空
      if (_temTimePeriod.time === '' || _temTimePeriod.time === '00:00') {
        _title += '#' + this.$t('iftttset.allday')
      } else {
        const _temst = parseInt(_temTimePeriod.time.split(':')[0])
        const _temed = parseInt(_temTimePeriod.time.split(':')[1])
        if (_temed > _temst) {
          _title += '#' + _temTimePeriod.time.split(':')[0] + ' ' + this.$t('iftttset.to') + ' ' + _temTimePeriod.time.split(':')[1]
        } else {
          _title += '#' + _temTimePeriod.time.split(':')[0] + ' ' + this.$t('iftttset.to') + ' ' + this.$t('iftttset.tommrow') + _temTimePeriod.time.split(':')[1]
        }
      }

      if (_temTimePeriod.holiday) {
        _title += '#' + this.$t('iftttset.noholiday')
      }

      return _title
    },

    /**
     * 把日期选择转化为对应值
     * 输入: ['Sat', 'Sun'] 输出: 双休日
     */
    weekCustomizeShown(weekParam, days) {
      if (weekParam === ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].join(',')) {
        return days[0].name
      } else if (weekParam === ['Mon', 'Tues', 'Wed', 'Thur', 'Fri'].join(',')) {
        return this.$t('iftttset.wordDay')
      } else if (weekParam === ['Sat', 'Sun'].join(',')) {
        return this.$t('iftttset.weekEnd')
      } else {
        return days[1].name
      }
    },

    // 选择重复的类型 每天 工作日 周末
    weekCustomize(index) {
      const currentWeek = this.weekTemp[index]
      let days = []
      if (currentWeek.selected) return
      this.activeWeekTemp.forEach((param, i) => {
        if (index === i) {
          this.weekSetShow = false
          param.selected = !param.selected

          switch (param.value) {
            case 'holidays':
              this.datasSelect(['holidays'])
              this.getProjectHolidays(new Date().getFullYear())
              break
            case 'notHolidays':
              this.datasSelect(['notHolidays'])
              this.getProjectHolidays(new Date().getFullYear())
              break
            case 'executeOnlyOnce':
              this.datasSelect(['executeOnlyOnce'])
              break
            case 'every':
              this.datasSelect(['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'])
              break
            case 'wordDay':
              this.datasSelect(['Mon', 'Tues', 'Wed', 'Thur', 'Fri'])
              break
            case 'weekEnd':
              this.datasSelect(['Sat', 'Sun'])
              break
            case 'customize':
              this.weekSetShow = true
          }
        } else {
          param.selected = false
        }
      })
    },

    // 选择时间
    timeCustomize(index) {
      const curretTime = this.timeTemp[index]

      if (curretTime.selected) return

      this.timeTemp.forEach((param, i) => {
        if (index === i) {
          param.selected = !param.selected

          switch (param.value) {
            case 'allday':
              this.timeValue = {
                start: '00',
                end: '24',
              }
              this.timeSetShow = false
              break
            case 'customize':
              this.timeSetShow = true
              break
          }
        } else {
          param.selected = false
        }
      })
    },

    // 日期选择
    datasSelect(arry) {
      if (!Array.isArray(arry)) return

      this.week.forEach(param => {
        if (arry.indexOf(param.value) < 0) {
          param.selected = false
        } else {
          param.selected = true
        }
      })
    },

    // 日期选择
    dateCustomize(index) {
      const currentDate = this.dateTemp[index].selected

      if (currentDate.selected) return

      this.dateTemp.forEach((param, i) => {
        if (index === i) {
          param.selected = true

          switch (param.value) {
            case 'along':
              this.dateSetShow = false
              break
            case 'customize':
              this.dateSetShow = true
              break
          }
        } else {
          param.selected = false
        }
      })
    },

    // 关闭弹窗
    handlerClose() {
      this.$emit('close')
    },

    monthsSelect(data) {
      data.selected = !data.selected
    },

    dataSelect(index) {
      this.week[index].selected = !this.week[index].selected
    },
  },
}
</script>

<style lang="scss" scoped>
.dataing_interval {
  margin-bottom: 14px;
  padding-left: 10px;
  line-height: 1.5;
}
.dialog-footer {
  display: flex;
  .button {
    width: 140px;
    height: 40px;
    border-radius: 3px;
    border: solid 1px #0046aa;
    margin: 0 30px;
    color: #0046aa;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }

  .button.button-ok {
    background: #0046aa;
    color: #fff;
  }
}
.iffttt_effect_time_dialog {
  margin-top: 15vh;
  ::v-deep .el-dialog {
    width: 37%;
    .dataing_line {
      width: 465px;
    }
  }
}
.dataing_line .week_list {
  width: auto !important;
  padding: 0 8px;
}
.dataing_line .warning {
  display: block;
  position: absolute;
  left: 13px;
  bottom: 9px;
  width: 14px;
}
.custom_type_list {
  padding: 14px 11px 16px;
  margin-bottom: 10px;
}

.custom-type-radio-group {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;

  ::v-deep .el-radio {
    margin-right: 0;
    white-space: nowrap;

    .el-radio__label {
      white-space: nowrap;
      padding-left: 6px;
    }
  }
}
.associated_period_set {
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &_text {
    cursor: pointer;
    position: absolute;
    top: 3px;
    left: 0;
    padding: 0 8px;
    font-size: 14px;
    color: #0080ff;
  }
}
.dataing_line ::v-deep .el-range__icon {
  line-height: 24px;
}
.dataing_line ::v-deep .el-range-editor--small .el-range-separator {
  line-height: 24px;
}
</style>
